<template>
  <div class="">
    <top />
		<div style="width: 100%;height: 55px;"></div>

    <div class="special">
      <div class="df">
        <div class="special-warp">
          <div>热门精品</div>
          <div>Popular boutique</div>
        </div>
      </div>

      <div class="special-content">
        <div
          class="special-item"
          v-for="(item, index) in recommendType"
          :key="index"
          @click="searchDo2(item.typename)"
        >
          <img :src="imageUrl(item.litpic)" :alt="'以图绘图印花设计网-' + item.typename" />
          <div class="special-text">{{ item.typename }}</div>
        </div>
      </div>
    </div>
        <foot />
  </div>
</template>

<script>
import top from "../../components/common/header.vue";
import foot from "../../components/common/footer.vue";

import { Popularboutiques } from "../../request/api";
export default {
  name: "",
  data() {
    return {
      recommendType: "",
    };
  },
  props: {},
  components: {
    top,
    foot,

  },
  mounted() {},
  created() {
	document.title = '以图绘图印花设计网-热门精品';
    this.getIndexData();
  },

  methods: {
    getIndexData() {
      Popularboutiques({}).then((res) => {
        this.recommendType = res.data;
      });
    },
    searchDo2(name) {
      this.$router.push({
        path: "/search",
        query: {
          keysWord: name,
          imgs: 0,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.special {
  width: 96%;
  margin: 0 auto;
  margin-top: 20px;
  .special-warp {
    display: flex;
    align-items: center;
  }

  .special-warp div:first-child {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }

  .special-warp div:first-child::after {
    content: "/";
    font-size: 12px;
    font-weight: 400;
    color: #afafaf;
    padding: 0 8px;
  }

  .special-warp div:last-child {
    font-size: 12px;

    font-weight: 400;
    color: #afafaf;
  }

  .special-content {
    padding-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .special-item {
      margin-bottom: 10px;
      width: 48%;
      height: 185px;
      background: #ffffff;
      border-radius: 3px;
      cursor: pointer;

      img {
        width: 100%;
        height: 154px;
        display: block;
      }

      .special-text {
        background-color: #ffffff;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        text-align: center;
        line-height: 31px;
      }
    }
    .special-item1 {
      margin-bottom: 10px;
      width: 48%;
      height: 195px;
      background: #ffffff;
      border-radius: 3px;
      cursor: pointer;
      text-align: center;
      img {
        border-radius: 50%;
        width: 74px;
        height: 74px;
        margin-top: 15px;
      }
      .name {
        font-size: 12px;
        margin-top: 20px;
        color: #08243c;
      }
      .more {
        margin: 0 auto;
        width: 60px;
        border: 1px solid #d2d7dc;
        border-radius: 10px;
        padding: 5px 15px;
        font-size: 12px;
        margin-top: 30px;
        color: #e66617;
      }
    }
  }
}
</style>